import { Trophy } from 'lucide-react';
import { cx } from './cx';
import SmoothMarquee from './SmoothMarquee';
import { wfTickStyle } from '@/styles/typography';

export interface WinTickerItem {
  player: string;
  game: string;
  amount: number;
}

export interface WinTickerProps {
  items: WinTickerItem[];
  className?: string;
}

const fmt = (v: number) =>
  `$${v.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

/** Wireframe `.tick` — dashed top, pad 6×18, font 10 × scale */
export default function WinTicker({ items, className }: WinTickerProps) {
  if (!items.length) return null;

  return (
    <SmoothMarquee
      className={cx('lobby-tick isolate', className)}
      copyClassName="gap-6"
    >
      {(copyId) =>
        items.map((item, i) => (
          <span
            key={`${item.player}-${item.game}-${item.amount}-${i}-${copyId}`}
            className="inline-flex items-center gap-1.5 whitespace-nowrap"
          >
            <Trophy
              className="text-money-out-soft shrink-0"
              style={{
                width: 'calc(10px * var(--proto-scale))',
                height: 'calc(10px * var(--proto-scale))',
              }}
              aria-hidden
            />
            <span className="font-ui text-caption-muted" style={wfTickStyle}>
              {item.player} won{' '}
              <span className="font-money font-semibold text-success tabular-nums">
                {fmt(item.amount)}
              </span>{' '}
              on {item.game}
            </span>
          </span>
        ))
      }
    </SmoothMarquee>
  );
}
